module.exports = __webpack_public_path__ + "static/media/Kenya.75417c34.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backs/Kenya.jpg
// module id = 888
// module chunks = 0